import { DetailedIconAddUser, Spacer } from '@zillow/constellation';

import ListingActivationTerm from '../../../../components/ListingActivationTerms';
import ApplicationShareLinks from '../ApplicationShareLinks';

import { StyledEmptyIconContainer, StyledEmptyStateContainer } from '../../../../StyledComponents';
import { EmptyStateBodyText, EmptyStateTitleText, StyledEmptySimpleCard } from '../../../../styles';

import type { ApplicationsSummary } from '../../interfaces';

type Props = {
  applicationsSummary?: ApplicationsSummary;
};

const EmptyApplicationsCard = ({ applicationsSummary }: Props) => (
  <StyledEmptySimpleCard data-testid="EmptyApplicationsCard">
    <StyledEmptyStateContainer>
      <StyledEmptyIconContainer>
        <DetailedIconAddUser />
      </StyledEmptyIconContainer>

      <EmptyStateTitleText asChild>
        <h4>No new applications</h4>
      </EmptyStateTitleText>

      <EmptyStateBodyText asChild>
        <p>
          You can invite renters to apply or wait for renters to apply via your listing on Zillow, Trulia, and HotPads.
          Applications received in the last 90 days will appear here.
        </p>
      </EmptyStateBodyText>

      <ApplicationShareLinks
        isTertiaryButtonStyling={false}
        hideViewOlderApplications={false}
        applicationsSummary={applicationsSummary}
      />

      <Spacer marginBottom="md" />
      <ListingActivationTerm actionText="By enabling or sharing applications" />
    </StyledEmptyStateContainer>
  </StyledEmptySimpleCard>
);

export default EmptyApplicationsCard;
